<!--
폐기요청 처리 컴포넌트
------------------------------------
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4 class="uk-text-center">폐기완료</h4>
            </div>

            <div class="uk-modal-body uk-padding-remove uk-flex uk-flex-between uk-child-width-1-2 uk-flex-top">

                <!-- 상품정보 표시 -->
                <div class="uk-flex uk-flex-wrap uk-padding-small" style="border-right: 1px solid #eee">
                    <div class="uk-width-1-1">
                        <app-column
                            class="uk-margin-small-bottom"
                            header="상품명"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.name }}
                        </app-column>
                    </div>



                    <div class="uk-width-auto uk-text-center">
                        <div class="uk-margin-right">
                            <img
                                :src="prod.img_url"
                                width="100"
                            />
                        </div>

                    </div>
                    <div class="uk-width-expand">
                        <app-column
                            class="uk-margin-small-bottom"
                            header="상품번호"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.id }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="배송단계"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.state_text }}
                        </app-column>




                        <app-column
                            class="uk-margin-small-bottom"
                            header="색상"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.color }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="사이즈"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.size }}
                        </app-column>



                        <app-column
                            class="uk-margin-small-bottom"
                            header="보관장소"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.storage }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="수량"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.amount }}
                        </app-column>

                    </div>
                </div>


                <!-- 안내 -->
                <div class="uk-padding-small">
                    해당상품을 실제 폐기처리 합니다.
                </div>
            </div>


            <div class="uk-modal-footer uk-text-right">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-danger"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    폐기완료
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (object) 상품정보
                prod: {},

                /**
                 * 입력값
                 */
                inputs: {},
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param prod_id 상품ID
             */
            form(prod_id) {

                // 초기화
                this.inputs = {
                    reason: null,
                };

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + prod_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.prod = response.prod;

                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {

                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/' + this.prod.id + '/destroy-done',
                        data: _.merge({
                            '_token': this.csrfToken,
                        }, this.inputs),
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    UIkit.modal.alert(response.msg).then(() => {
                        $.app.refresh();
                    });
                });
            },

            /**
             * 브라우저 윈도우(탭) 닫기
             */
            closeWindow() {
                window.close();
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>